import { render, staticRenderFns } from "./returnbooking.vue?vue&type=template&id=53b0f418"
import script from "./returnbooking.vue?vue&type=script&lang=js"
export * from "./returnbooking.vue?vue&type=script&lang=js"
import style0 from "./returnbooking.vue?vue&type=style&index=0&id=53b0f418&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports